export default "__VITE_ASSET__CDu6OFBy__"